import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '@/ui';
import { IContentBlockSchemaItem } from '@/models/content-block-schema.model';
import { getContentBlockPaletteIconSrc } from '../../helpers/blockPaletteIcon';
import { contentBlockTypeLabelKey } from '../../helpers/contentBlockI18n';
import { StyledBlockPaletteRoot } from './BlockPaletteStyles';

type TBlockPalette = {
  schemas: IContentBlockSchemaItem[];
  onAdd: (type: string) => void;
};

const PALETTE_ICON_SLOT_PX = 28;

const BlockPaletteIcon = ({ blockType }: { blockType: string }) => (
  <span
    style={{
      width: PALETTE_ICON_SLOT_PX,
      height: PALETTE_ICON_SLOT_PX,
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    aria-hidden
  >
    <img
      src={getContentBlockPaletteIconSrc(blockType)}
      alt=""
      style={{ maxWidth: PALETTE_ICON_SLOT_PX, maxHeight: PALETTE_ICON_SLOT_PX, objectFit: 'contain' }}
      onError={(e) => {
        e.currentTarget.style.visibility = 'hidden';
      }}
    />
  </span>
);

const BlockPalette = ({ schemas, onAdd }: TBlockPalette) => {
  const { t } = useTranslation(['contentPages']);

  return (
    <StyledBlockPaletteRoot>
      <Card title={t('palette_title')} size="small">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {schemas.map((item) => (
            <Button
              key={item.type}
              type="text"
              onClick={() => onAdd(item.type)}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 10,
                paddingLeft: '0.5rem',
              }}
            >
              <BlockPaletteIcon blockType={item.type} />
              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  textAlign: 'left',
                  fontSize: 12,
                  lineHeight: '16px',
                  whiteSpace: 'normal',
                  overflowWrap: 'anywhere',
                }}
              >
                {t(contentBlockTypeLabelKey(item.type), { defaultValue: item.label })}
              </span>
            </Button>
          ))}
        </div>
      </Card>
    </StyledBlockPaletteRoot>
  );
};

export default BlockPalette;
